﻿import $ from "jquery";
import "bootstrap";
import { GuiDetailAktion } from "./GuiDetailAktion";


export class GuiDetailFakturaAktion extends GuiDetailAktion {

    constructor() {
        super();
    }

    attachEvents() {
        super.attachEvents();

        $("button.erz-btn-cut-kostenart").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickKostenartCut(e));

        $("button.ocrlink").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickOcrModal(e));
        $("button.btn-ocrlink").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickOcrLink(e));

    }
    
    //#region Cut Kostenart

    clickKostenartCut(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickKostenartCut");
        e.preventDefault();
        // ID in Hidden Field übernehmen
        const aktionPositionId = $(e.currentTarget).closest("div.row.erz-list-element").data("id") as string;

        $("#mdlDeletePosition h5.modal-title").html("Kostenart lösen");
        $("#mdlDeletePosition div.modal-body p").html("Wollen Sie die Kostenart wirklich lösen?");
        $("#mdlDeletePosition #mdlDeletePositionbtnDelete").html("Lösen");
        $("#mdlDeletePosition").modal("show");
        $("#mdlDeletePositionbtnDelete").on("click", (ev: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickKostenartCutConfirm(ev, aktionPositionId));
    }

    clickKostenartCutConfirm(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, aktionPositionId: string) {
        this.log(`clickKostenartCutConfirm: ${aktionPositionId}`);
        $("#GuiAktion").val("CutPosition");
        $("#AktionPositionId").val(aktionPositionId);

        if (!this.form.checkValidity()) {
            e.stopPropagation();
        } else {
            this.lock();
            // Submit form über Browser Button
        }
    }

    //#endregion

    //#region ### OCR ###

    clickOcrModal(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickOcrModal");
        e.preventDefault();
        e.stopPropagation();
        const aktionPositionId = $(e.currentTarget).closest("div.erz-list-element").data("id");
        const div = $(e.currentTarget).closest("div.erz-detail-list");
        const url = div.data("url-ocrdaten") + "?aktionPositionId=" + aktionPositionId;
        $("#mdlOcrLink").remove();
        
        $.get(url).done(
            (data: string) => {
                const modalDiv = data;
                $("#detailForm").append($(modalDiv));
                $("#mdlOcrLink").modal("show");
                $("button.btn-ocrlink").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickOcrLink(e));
                $("select#modalOcrFilter").on("change", () => this.changeOcrFilter());
                this.applyOcrFilter();
            });

    }

    clickOcrLink(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log(`clickOcrLink`);
        const ocrPositionId = $(e.currentTarget).data("id");
        const aktionPositionId = $("#mdlOcrLink").data("aktionpositionid");

        $("#GuiAktion").val("LinkPositionOcr");
        $("#AktionPositionId").val(aktionPositionId);
        $("#OcrPositionId").val(ocrPositionId);

        if (!this.form.checkValidity()) {
            e.stopPropagation();
        } else {
            this.lock();
            // Submit form über Browser Button
        }
    }

    changeOcrFilter() {
        this.log(`changeOcrFilter`);
        this.applyOcrFilter();
    }

    applyOcrFilter() {
        this.log(`changeOcrFilter`);
        const value = $("select#modalOcrFilter").val();
        const rows = $("#mdlOcrLink div.erz-list-element");
        rows.each((index, row) => {
            const $row = $(row);
            if (value == "alle") {
                $row.show();
                return;
            }
            /*
             Link = 0,
Unlink = 1,
Ignore = 2,
Locked = 3, */
            const typ = $row.data("typ");
            if (value == "offen") {
                if (typ == "Link") {
                    $row.show();
                } else {
                    $row.hide();
                }
                return;
            }
            if (value == "verbunden") {
                if (typ == "Unlink") {
                    $row.show();
                } else {
                    $row.hide();
                }
                return;
            }


        });
    }


    //#endregion



    protected getUrlParameter(): string {
        const fakturaId = $("#FakturaId").val();
        return `fakturaId=${fakturaId}`;
    }
}
